import { combineReducers, configureStore } from "@reduxjs/toolkit";
import mainSlice from "./reducer";

const rootReducer = combineReducers({
  mainSlice,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
